//key chức năng

export const FUNCTION_KEY = {
  ACCOUNT: "FAC", // Tài khoản
  ACCOUNT_MANAGER: "FAC1", // Quản lý tài khoản
  TRANSACTIONS_STATEMENTS: "FAC2",
  TRANSACTION_TRACKING: "FAC3",
  CHANGE_PASSWORD: "FAC4",
  LOG_OUT: "FAC5",
  TRANSACTION_HISTORY: "FAC6",

  TRANSFER: "FTF", // Chuyển tiền
  LOCAL_TRANSFER: "FTF1",
  LOCAL_TRANSFER_OTHER_CIF: "FTF7",
  FOREIGN_TRANSFER: "FTF2",
  TRANSFER_24_7: "FTF3",
  TRANSFER_NHANH_247_QR: "FTF9",
  STOCK_TRANSFER: "FTF4",
  TRANSFER_CHARITY: "FTF10",
  CASH_BY_CODE: "FTF5",
  HISTORY_CASH_BY_CODE: "FTF6",
  CHANGE_TRANSACTION_LIMIT: "FTF8",

  TOP_UP: "FTU", // Nạp tiền
  PHONE_TOPUP: "FTU1",

  BILLING: "FBL", // Hóa đơn

  // cHƯC NĂNG KHÁC
  OTHERS: "FOT",
  SEARCH_ATM_PROVIDER: "FOT1",
  EXCHANGE_RATE: "FOT2",
  HOTLINE: "FOT3",
  VERSION: "FOT4",
  BANK_INFO: "FOT5",
  SMS_BANKING: "FOT6",

  // Chức năng tiết kiệm
  SAVING: "FSV", // Tiết kiệm
  SAVING_ADVICE: "FSV1", //Tư vấn tiết kiệm
  SAVING_OPEN_BOOK: "FSV2", // Mở sổ tiết kiệm
  SAVING_TOPUP: "FSV3", // Nạp thêm tiền vào sổ
  SAVING_BOOK: "FSV4", // Tất toán sổ tiết kiệm

  // Chuc nang dich vu
  SIGN_SERVICE: "AUTO", // Đăng ký dịch vụ
  AUTO_TOPUP: "AUTO1",
  AUTO_BILLING: "AUTO2",

  QR: "QRP", // QRcode

  CARD_SERVICE: "CRD", // Dịch vụ thẻ
  CARD_LIST: "CRD", // Danh sách thẻ
  THANH_TOAN_THE_TIN_DUNG: "CRD9",
  KHOA_MO_GD_TRUC_TUYEN: "CRD4",

  TAKE_MONNEY: "LOA", // Khoản vay
  LOAN: "LOA1",
  LIST_TAKE_MONNEY: "LOA2", // Danh sách khế ước
  HISTORY_TAKE_MONNEY: "LOA3", // Lịch sử vay

  ONLINE_LOAN: "LOA4",
  ONLINE_LOAN_CREATE: "LOA5",
  ONLINE_LOAN_TERMINATE: "LOA7",
  ONLINE_LOAN_MORTGAGE: "LOA6",

  PUSH: "FPN", // Push

  SALE_NEWS: "SALE", // Thông tin khuyến mãi

  // Dịch vụ Thanh toán (TopUp + Billing)
  BILLING_TOPUP_SERVICE: "BILLING_TOPUP_SERVICE",

  // Tư vấn tài chính
  TU_VAN_TAI_CHINH: "TU_VAN_TAI_CHINH",

  // Đầu tư
  DAU_TU: "DAU_TU",

  // Hướng dẫn sử dụng
  HUONG_DAN_SU_DUNG: "HUONG_DAN_SU_DUNG",

  //Khách hàng thân thiết
  LOYALTY: "LOL",
  LOYALTY_MAIN: "LOL1",
  LOYALTY_DETAIL: "LOL2",
  LOYALTY_CHANGE_GIFT: "LOL3",

  // Cài đặt Smart OTP
  SETTING_SMART_OTP: "SMO",
  REGISTRATION_SMART_OTP: "SMO1",
  ACTIVATED_SMART_OTP: "SMO2",
  CHANGE_PIN_SMART_OTP: "SMO3",
  CHANGE_DEVICES_SMART_OTP: "SMO4",
  TOUCH_FACE_SMART_OTP: "SMO5",
  GET_SMART_OTP: "SMO6",
  PIN_RECOVERY_SMART_OTP: "SMO7",
  LOST_DEVICE_OR_REACTIVED_SMART_OTP: "SMO8",
};
